<template>
  <div class="layout-box-ale">
    <ale-head :loginToken="loginToken" :showIndex="showIndex" @updateShowIndex="(val) => showIndex = val"/>
    <login v-if="!loginToken" @getData="getAllData" />
    <screen1 v-if="showIndex === 0 && loginToken" :getData="data1" screen-name="重要指标"/>
    <screen2 :tableSet="tableSet" :getData="data2" v-if="showIndex === 1 && loginToken" screen-name="现货均价"/>
    <screen2 :tableSet="tableSet" :getData="data3" v-if="showIndex === 2 && loginToken" screen-name="价差"/>
    <screen3 echartId="1" :getData="ehcartData1" v-if="showIndex === 3 && loginToken" screen-name="涤纶库存/负荷"/>
    <screen3 echartId="2" :getData="ehcartData2" v-if="showIndex === 4 && loginToken" screen-name="锦纶库存/负荷"/>
    <screen3 echartId="3" :getData="ehcartData3" v-if="showIndex === 5 && loginToken" screen-name="氨纶库存/负荷"/>
    <screen3 echartId="4" :getData="ehcartData4" v-if="showIndex === 6 && loginToken" screen-name="粘胶库存/负荷"/>
    <screen3 echartId="5" :getData="ehcartData5" v-if="showIndex === 7 && loginToken" screen-name="棉纱库存/负荷"/>
  </div>
</template>

<script>
import aleHead from './modules/aleHead'
import screen1 from './modules/screen1'
import screen2 from './modules/screen2'
import screen3 from './modules/screen3'
import login from './modules/login'
import myStorage from '../../bll/utils';
export default {
  name: 'index',
  components: {
    aleHead,
    screen1,
    screen2,
    screen3,
    login
  },
  data () {
    return {
      statre: false,
      loginToken: myStorage.getItem('localStorage','token') || null,
      showIndex: 0,
      data1: [],
      data2: [],
      data3: [],
      tableSet: {
        Rolling: true,
        height: 250,
        stripe: true,
        id: 1
      },
      echartSet: [ // 负荷在前 库存在后
        {ids: ['573', '69'], obj: 'ehcartData1', name: '涤纶'},
        {ids: ['121', '123'], obj: 'ehcartData2', name: '锦纶'},
        {ids: ['134', '136'], obj: 'ehcartData3', name: '氨纶'},
        {ids: ['149', '2064'], obj: 'ehcartData4', name: '粘胶'},
        {ids: ['2361', '712'], obj: 'ehcartData5', name: '棉纱'}
      ],
      ehcartData1: { data1: [], data2: [], name1: '', name2: '', date: [] },
      ehcartData2: { data1: [], data2: [], name1: '', name2: '', date: [] },
      ehcartData3: { data1: [], data2: [], name1: '', name2: '', date: [] },
      ehcartData4: { data1: [], data2: [], name1: '', name2: '', date: [] },
      ehcartData5: { data1: [], data2: [], name1: '', name2: '', date: [] }
    }
  },
  mounted () {
    // localStorage.removeItem('token')
    console.log('loginToken333:', this.loginToken)
    if (this.loginToken) {
      this.getAllData(this.loginToken)
    }
  },
  methods: {
    getAllData (token) {
      console.log('来token了', token)
      this.loginToken = token
      this.getIndicator()
      this.getPriceIndicator()
      this.getCashFlowIndicator()
      this.getAllInventoryLoad()
    },
    getIndicator () {
      const url = '/sle/indicator/data/head'
      this.$api.post(url, {}, (res) => {
        console.log('res1:', res)
        if (res.data.code === '000000') {
          this.data1 = res.data.data || []
        }
      }, 'json')
    },
    getPriceIndicator () {
      const url = '/sle/indicator/data/price'
      this.$api.post(url, {}, (res) => {
        console.log('res2:', res)
        if (res.data.code === '000000') {
          this.data2 = res.data.data || []
        }
      }, 'json')
    },
    getCashFlowIndicator () {
      const url = '/sle/indicator/data/cashFlow'
      this.$api.post(url, {}, (res) => {
        console.log('res3:', res)
        if (res.data.code === '000000') {
          this.data3 = res.data.data || []
        }
      }, 'json')
    },
    getAllInventoryLoad () {
      const url = '/sle/indicator/data/exponent'
      this.$api.post(url, {}, (res) => {
        console.log('res4:', res)
        if (res.data.code === '000000') {
          const data = res.data.data
          this.echartSet.map(value => {
            const data1 = data.filter(val => val.indicatorId === value.ids[0])[0]
            const data2 = data.filter(val => val.indicatorId === value.ids[1])[0]
            console.log(data1, data2, value.obj, value.name)
            this.distributionAssignment(data1, data2, value.obj)
          })
        }
      }, 'json')
    },
    distributionAssignment (data1, data2, obj) {
      const chartdata = this.groupByProperty(data1.dataVos)
      const chartdata2 = this.groupByProperty(data2.dataVos)
      this[obj] = {
        data1: chartdata.data,
        data2: chartdata2.data,
        name1: data1.name,
        name2: data2.name,
        date: chartdata.date
      }
      console.log('数据拆分了', chartdata)
    },
    groupByProperty (arr) {
      let data = []
      let date = []
      arr.map(val => {
        data.push(val.value)
        date.push(val.date)
      })
      return {data, date}
    }
  }
}
</script>

<style scoped>
.layout-box-ale{
  position: relative;
  width: 100%;
  height: 100%;
  user-select:none; /* CSS3属性 */
  background: url("../../assets/ale/bj.jpg") no-repeat center/100%;
}

</style>



// WEBPACK FOOTER //
// src/views/ale/index.vue